import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import {
  BonusType,
  LinkMode,
  UserInfo,
  Wheel,
  WheelPrizeType,
} from '@longnecktech/splash-commons-fe';
import { NextSpinInfo } from '@shared/types/next-spin-info';
import { Spin } from '@shared/types/spin';
import { delay, of, throwError } from 'rxjs';
import { isStorePreview } from './store-preview';
import { asset, luckyDaysTheme } from './luckydays-theme';

export const previewUser: UserInfo = {
  uuid: 'local-preview',
  externalId: 'local-preview',
  createdTs: '',
  lastLoginTs: null,
  username: 'Preview',
  email: '',
  roles: [],
  locked: false,
  token: '',
  country: null,
  balance: 0,
  test: true,
  language: 'en',
  anonymous: false,
  blocked: false,
  identifier: null,
};

export const previewGame: Wheel = {
  uuid: 'local-wheel-store',
  name: 'Lucky Days',
  startTs: '2026-01-01T00:00:00Z',
  endTs: '2099-01-01T00:00:00Z',
  paused: false,
  ended: false,
  hideCloseButton: false,
  termsLinkMode: LinkMode.HIDDEN,
  gameRulesLinkMode: LinkMode.HIDDEN,
  faqLinkMode: LinkMode.HIDDEN,
  campaign: null,
  spinsPerDay: 100,
  delayBetweenSpins: 0,
  loginLink: null,
  featuredProducts: [],
  submissionCount: 0,
  termsAndConditions: null,
  rules: null,
  faq: null,
  settlementPostMessage: false,
  test: true,
  theme: luckyDaysTheme,
  segments: [25, 20, 5, 5, 20, 5, 10, 15, 15, 10].map((value, index) => {
    const coins = index % 2 === 1;
    const icon = asset(coins ? 'coin.png' : 'free-spins.png');
    return {
      uuid: `segment-${index}`,
      index,
      text: String(value),
      chance: 10,
      backgroundColor: coins ? '#00b3cd' : '#ee0000',
      iconAsset: icon,
      assetLabel: coins ? 'LD Coins' : 'Free Spins',
      prize: {
        type: WheelPrizeType.CUSTOM,
        currency: '',
        value,
        label: coins ? `${value} LD Coins` : `${value} Free Spins`,
        infoLabel: '',
        image: icon,
        bonusType: BonusType.FreeSpins,
        slug: coins ? 'demo-coins' : 'demo-free-spins',
      },
    };
  }),
};

const info = (): NextSpinInfo => ({
  allowedToSpin: true,
  nextSpinInSeconds: 0,
  lastSpinTransaction: null,
  startTs: Date.now(),
});
let spinIndex = 0;

export const previewInterceptor: HttpInterceptorFn = (request, next) => {
  if (!isStorePreview()) return next(request);
  const path = new URL(request.url, window.location.origin).pathname;
  let body: unknown;
  if (path === '/api/wheel/game' && request.method === 'GET')
    body = previewGame;
  else if (
    path === `/api/wheel/spin/${previewGame.uuid}` &&
    request.method === 'GET'
  )
    body = info();
  else if (
    path === `/api/wheel/spin/${previewGame.uuid}` &&
    request.method === 'POST'
  ) {
    const sequence = [1, 3, 2, 7, 9, 0, 5];
    body = {
      uuid: crypto.randomUUID(),
      game: previewGame,
      userInfo: previewUser,
      createdTs: new Date(),
      segment: previewGame.segments[sequence[spinIndex++ % sequence.length]],
      nextSpinInfo: info(),
    } satisfies Spin;
  } else if (path === '/api/public/auth/token') body = previewUser;
  else if (path.startsWith('/api/'))
    return throwError(
      () => new Error('This API is not available in the local preview.'),
    );
  else return next(request);
  return of(new HttpResponse({ status: 200, body })).pipe(delay(180));
};
